import React from 'react';
import { keys, values, map } from 'ramda';
import { Route, Switch } from 'react-router-dom';
import { languageService } from 'js/services/language.service';

/**
 * Router that provides pathLang and path parameters for language detection and routing.
 */
export const LanguageRouter = ({ children }) => {
    const longLocales = keys(languageService.shortLocalesMapping);
    const shortLocales = values(languageService.shortLocalesMapping);
    const aliasesForLocales = values(languageService.aliasLocaleMapping);
    const imsLocales = map(languageService.convertToIMS, longLocales);
    const joinedLocales = [].concat(longLocales, shortLocales, aliasesForLocales, imsLocales).join('|');

    return (
        <Switch>
            <Route path={`/:pathLang(${joinedLocales})?/:path(.*)?`}>
                {children}
            </Route>
        </Switch>
    );
};
